import { IAIAnalyzeClass } from './i-ai-analyze-class';
import { IAIObjectDetectionClass } from './i-ai-object-detection-class';

export class AIObjectDetectionAnalyzeClass implements IAIAnalyzeClass {
  public type = 'object_detection';
  public version = 0;
  constructor(public required_classes: IAIObjectDetectionClass[]) {}
}
